module.exports = __webpack_public_path__ + "static/media/border-none.41196a7b.svg";